/**
 * エレメントをフェードインさせる関数
 * @param {HTMLElement} element フェードインさせる対象のエレメント
 * @param {number} duration フェードインのアニメーション時間（ミリ秒）
 */
export function fadeInElement( element, duration ) {
	element.style.opacity = '0';
	element.style.transition = `opacity ${ duration / 1000 }s`;
	element.style.display = 'block';

	setTimeout( () => {
		element.style.opacity = '1';
	}, 0 );
}

/**
 * エレメントをフェードアウトさせる関数
 * @param {HTMLElement} element フェードアウトさせる対象のエレメント
 * @param {number} duration フェードアウトのアニメーション時間（ミリ秒）
 */
export function fadeOutElement( element, duration ) {
	element.style.opacity = '1';
	element.style.transition = `opacity ${ duration / 1000 }s`;

	setTimeout( () => {
		element.style.opacity = '0';
		setTimeout( () => {
			element.style.display = 'none';
		}, duration );
	}, 0 );
}

/**
 * エレメントをフェードアウト（透過のみ）させる関数
 * @param {HTMLElement} element フェードアウトさせる対象のエレメント
 * @param {number} duration フェードアウトのアニメーション時間（ミリ秒）
 */
export function fadeOutOpacityElement( element, duration ) {
	element.style.opacity = '1';
	element.style.transition = `opacity ${ duration / 1000 }s`;

	setTimeout( () => {
		element.style.opacity = '0';
	}, 0 );
}
